module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ("gh-radio-group radio-group-" + _vm.name)
  }, [_c('div', {
    staticClass: "radio-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      staticClass: "gh-radio",
      attrs: {
        "if": "items"
      },
      on: {
        "click": function($event) {
          return _vm.selectRadio((_vm.name + "-" + index), item)
        }
      }
    }, [(item.pinned) ? _c('v-icon', {
      staticClass: "approved"
    }, [_vm._v("mdi-approval")]) : [_c('input', {
      staticClass: "hide",
      attrs: {
        "id": (_vm.name + "-" + index),
        "type": "radio",
        "name": _vm.name
      },
      domProps: {
        "value": item.value,
        "checked": _vm.checked(item)
      },
      on: {
        "change": function($event) {
          return _vm.toggleRadio(_vm.name)
        }
      }
    }), _vm._v(" "), _c('v-icon', {
      class: ("icon " + _vm.name + "-" + index)
    }, [_vm._v(_vm._s(_vm.icon(item)))])], _vm._v(" "), _c('label', [_vm._v(_vm._s(item.label))])], 2)
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8275a264","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/gh-radio-group.vue
// module id = 739
// module chunks = 1